import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { SiteProvider } from "@/context/SiteContext";
import { PageWipeProvider } from "@/components/PageWipe";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
    }, []);

    return (
        <SiteProvider>
            <BrowserRouter>
                <PageWipeProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/projects/:id" element={<ProjectDetail />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </PageWipeProvider>
            </BrowserRouter>
            <Toaster position="top-center" />
        </SiteProvider>
    );
}

export default App;
